<script>
	export let type = null;
</script>

<slot />
